export const getConfigValue = (key: string): string => {
  const value = import.meta.env[key]
  if (!value && import.meta.env.NODE_ENV !== 'test') {
    throw new Error(`"${key}" is missing from configuration file`)
  }
  return value
}
